<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="23.371" height="14" viewBox="0 0 23.371 14" class="scaling-svg">
      <g transform="translate(14.81 5.907)">
        <path
          d="M3.837,8.093A3.95,3.95,0,0,1,0,4.046,3.95,3.95,0,0,1,3.837,0,3.95,3.95,0,0,1,7.673,4.046,3.95,3.95,0,0,1,3.837,8.093ZM3.837.9A3.072,3.072,0,0,0,.852,4.046,3.072,3.072,0,0,0,3.837,7.194,3.072,3.072,0,0,0,6.821,4.046,3.072,3.072,0,0,0,3.837.9Z"
          transform="translate(0.444)"
        />
        <path
          d="M.182.081a.412.412,0,0,1,.594.11A1.832,1.832,0,0,0,1.829.965c.419.092,1-.009,1.691-.816a.411.411,0,0,1,.6-.033A.467.467,0,0,1,4.153.75a2.543,2.543,0,0,1-2.5,1.095A2.682,2.682,0,0,1,.077.707.465.465,0,0,1,.182.081Z"
          transform="translate(2.149 3.597)"
        />
        <path
          d="M.1,1.079A1.647,1.647,0,0,1,1.723,0a.438.438,0,0,1,.426.45A.438.438,0,0,1,1.723.9a.8.8,0,0,0-.826.5.972.972,0,0,0,.275.985.467.467,0,0,1,0,.636.411.411,0,0,1-.6,0A1.9,1.9,0,0,1,.1,1.079Z"
          transform="translate(0 0.899)"
        />
        <path
          d="M2.051,1.079A1.647,1.647,0,0,0,.426,0,.438.438,0,0,0,0,.45.438.438,0,0,0,.426.9a.8.8,0,0,1,.826.5.972.972,0,0,1-.275.985.467.467,0,0,0,0,.636.411.411,0,0,0,.6,0A1.9,1.9,0,0,0,2.051,1.079Z"
          transform="translate(6.412 0.899)"
        />
      </g>
      <g id="Icon_good-2" data-name="Icon_good">
        <path
          d="M6.637,14A6.834,6.834,0,0,1,0,7,6.834,6.834,0,0,1,6.637,0a6.834,6.834,0,0,1,6.637,7A6.834,6.834,0,0,1,6.637,14Zm0-12.445A5.315,5.315,0,0,0,1.475,7a5.315,5.315,0,0,0,5.162,5.445A5.315,5.315,0,0,0,11.8,7,5.315,5.315,0,0,0,6.637,1.555Z"
          transform="translate(0.768)"
        />
        <path
          d="M.315.141A.714.714,0,0,1,1.342.332,3.169,3.169,0,0,0,3.164,1.669C3.89,1.828,4.9,1.654,6.089.258A.711.711,0,0,1,7.13.2a.808.808,0,0,1,.055,1.1C5.722,3.013,4.21,3.487,2.864,3.192A4.64,4.64,0,0,1,.133,1.224.805.805,0,0,1,.315.141Z"
          transform="translate(3.718 6.222)"
        />
        <path
          d="M.17,1.866A2.849,2.849,0,0,1,2.98,0a.758.758,0,0,1,.737.778.758.758,0,0,1-.737.778,1.384,1.384,0,0,0-1.43.856,1.682,1.682,0,0,0,.476,1.7.808.808,0,0,1,0,1.1.711.711,0,0,1-1.043,0A3.288,3.288,0,0,1,.17,1.866Z"
          transform="translate(0 1.556)"
        />
        <path
          d="M3.548,1.866A2.849,2.849,0,0,0,.737,0,.758.758,0,0,0,0,.778a.758.758,0,0,0,.737.778,1.384,1.384,0,0,1,1.43.856,1.682,1.682,0,0,1-.476,1.7.808.808,0,0,0,0,1.1.711.711,0,0,0,1.043,0A3.288,3.288,0,0,0,3.548,1.866Z"
          transform="translate(11.092 1.556)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ContractorsIcon extends Vue {}
</script>

<style>
</style>
